(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightPickerController', InsightPickerController);

    /* @ngInject */
    function InsightPickerController($scope, $state, triSettings, $mdDialog, Dashboard, Feature, Folder, ParseLinks, AlertService, ContentAction, $mdToast, $filter, CONTENT_META, filter, selectedInsights, allowMultiSelect, paginationConstants) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.pageTitleKey = $filter('translate')('autoComplete.contentPicker.content');
        vm.predicate = "name";
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.showFolders = false;
        vm.selected = [];
        vm.allowMultiSelect = allowMultiSelect;
        vm.currentSelectedCards = selectedInsights;
        $scope.secondaryColor = triSettings.getSkinModel().secondary_color_hex;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.getQueryString = getQueryString;

        vm.defaultFolder = {
            id: "default",
            name: "Default",
            description: "Default"
        };

        vm.selectedFolder = vm.defaultFolder;


        function loadAll() {
            vm.loadingData = true;
            //console.log('selected insights: ' + vm.currentSelectedCards);
            Dashboard.insights({
                page: 0,
                size: vm.query.limit,
                sort: sort(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }, onSuccess, onError);

            function sort() {
                return ['name' + ',' + 'asc'];
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                vm.page = 1;
                vm.loadingData = false;
            }

            function onError(error) {
                vm.loadingData = false;
                AlertService.error(error.data.message);
            }
        }

        vm.getMediaUrl = function(mediaUrl){
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.selectFolder = function(folder) {
            vm.updateObject = false;
            vm.selectedFolder = folder;
            vm.loadAll();
        }

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        }

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        }

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        }

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedCards);
        }

        vm.close = function() {
            //console.log('vm.currentSelectedCards ' + vm.currentSelectedCards);
            $mdDialog.cancel();
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Dashboard.insights({
                page: vm.page - 1,
                size: vm.query.limit,
                sort: getSortOrder(),
                query: getQueryString(),
                is_web: vm.isWeb,
                is_not_filter: vm.isNotFilter
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.contents = data;
            });
        }

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        }

        function getQueryString() {
            var contentQuery = filter;
            if (vm.query.filter.length <= 0) {
                vm.query.filter = '';
            }

            var quoteEscapedStr = String(vm.query.filter).replace(/([\\"])/g, '\\$1');
                return 'name=re="' + quoteEscapedStr + '"';

            return contentQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function resetModal() {
            loadAll();
            vm.showFolders = false;
            AlertService.displayToast($mdToast);
        };
        vm.loadAll();
    }
})();
